import React from "react";
import PropTypes from "prop-types";
import useStyles from "@hooks/useStyles";
import useConstants from "@hooks/useConstants";
import useStaticContext from "@hooks/useStaticContext";
import useStores from "@hooks/useStores";

import Box from "@material-ui/core/Box";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";

import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";

import ContentTOC from "./ContentTOC";
import ContentPromo from "./ContentPromo";
import ContentSideInfoBox from "./ContentSideInfoBox";

import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import ContentBadge from "./ContentBadge";
import LazyLoad from "@custom/LazyLoad";

const { SITE_NAME } = process.env;

const ContentSide = () => {
	const classes = useStyles("Content");
	const { app } = useStaticContext();
	const { contentStore: store } = useStores();
	const { city, state } = app.location || {};

	const [open, setOpen] = React.useState(false);

	const handleClickOpen = () => {
		setOpen(true);
	};

	const handleClose = () => {
		setOpen(false);
	};

	const {
		slideCTAButton,
		contentPromo1,
		contentPromo2,
		contentPromo1sub,
		contentPromo2sub,
		contentPromo1button,
		contentPromo2button,
	} = useConstants("ContentViewModel");

	return (
		<Box
			component="aside"
			display={"flex"}
			flexDirection={"column"}
			height="100%"
			pt={12}
		>
			<ContentBadge />

			<Box flexBasis={"20%"}>
				<Box mb={8}>
					<ContentPromo
						header={
							<>
								{city ? (
									<>{`20+ ${store.service?.phrase} near ${city}, ${state}`}</>
								) : (
									<>{`20+ ${store.service?.phrase} near you`}</>
								)}
							</>
						}
						subHeader={contentPromo1sub}
						right={true}
						icon={true}
						hideZip={true}
						button={contentPromo1button}
						href={SITE_NAME === "trustedcare" ? "/" : store.service?.url}
						target="_blank"
					/>
				</Box>

				<ContentSideInfoBox />

				{store.hasTableOfContents && (
					<Box position={"sticky"} top={90} right={0}>
						<Box display={"flex"} flexDirection={"column"}>
							<Box borderRadius={8} bgcolor="#fafafa" height="100%">
								<div className={classes.asideBox}>
									<div className={classes.asideBoxHeader}>
										Table of contents
									</div>
								</div>
								<Box p={"10px 10px 10px 0"}>
									<div className={classes.TOCList}>
										<ContentTOC />
									</div>
								</Box>
								<Box
									borderRadius={"0px 0px 8px 8px"}
									borderTop={"1px solid #eee"}
								>
									<Box p={"12px 24px"} fontWeight={600} fontSize={18}>
										<Button
											fullWidth
											href={
												SITE_NAME === "trustedcare"
													? "/"
													: store.service?.url +
													  "?utm_source=content&utm_medium=toc&utm_content=content&utm_campaign=toc"
											}
											target="_blank"
											size={"large"}
											color={"primary"}
											variant="contained"
											disableElevation
											endIcon={<ArrowForwardIcon />}
										>
											{slideCTAButton}
										</Button>
									</Box>
								</Box>
							</Box>
							{/* <Box mt={8} flex={"0 0 auto"} height={350} minHeight={350}>
							<ContentPromo header="Get free estimates from AC companies near you." />
						</Box> */}
						</Box>
					</Box>
				)}
			</Box>
			<Box flexBasis={"80%"}>
				<Box position={"sticky"} top={90} right={0}>
					<Box mt={8}>
						<ContentPromo
							header={
								<>
									{city ? (
										<>{`20+ ${store.service?.phrase} near ${city}, ${state}`}</>
									) : (
										<>{`20+ ${store.service?.phrase} near you`}</>
									)}
								</>
							}
							subHeader={contentPromo2sub}
							right={true}
							icon={true}
							hideZip={true}
							button={contentPromo2button}
							href={SITE_NAME === "trustedcare" ? "/" : store.service?.url}
						/>
					</Box>

					{store.relatedArticles.length > 0 && (
						<Box mt={8}>
							<Paper variant={"outlined"}>
								<div className={classes.asideBox}>
									<div className={classes.asideBoxHeader}>Related articles</div>
								</div>
								<Box p="10px 10px 10px 0px">
									<div className={classes.asideRelatedBox}>
										<List>
											{store.relatedArticles.map((article, i) => (
												<ListItem
													key={`article-${i}`}
													button
													component="a"
													href={article.url}
													target="_blank"
												>
													<ListItemIcon className={classes.asideIcon}>
														<LazyLoad>
															<img
																className={classes.relatedThumbnail}
																src={article.thumbnail?.cdnUrl}
																title={article.title}
																alt={article.name}
																loading={"lazy"}
																decoding="async"
															/>
														</LazyLoad>
													</ListItemIcon>
													<ListItemText
														classes={{ primary: classes.listItemText }}
														primary={article.name}
													/>
												</ListItem>
											))}
										</List>
									</div>
								</Box>
							</Paper>
						</Box>
					)}
				</Box>
			</Box>
		</Box>
	);
};

ContentSide.propTypes = {};
export default ContentSide;
